import { RequestError, RequestErrorArgs } from "./RequestError"

export class NetworkError extends RequestError {
  constructor(args: RequestErrorArgs) {
    super(args)
    this.name = "NetworkError"
  }
}
